import React from 'react';
import Page from '../../components/Page/Page';
import seo from '../../constants/seo';

const Bnb = () => (
  <Page {...seo.bnb}>
    <h2 className="mt-0 pt-0">BED AND BREAKFASTS</h2>
    <p className="mb-1">Hello there,</p>
    <p>
      We understand that your guests are like family to you, and we understand you get more
      queries than you can handle about trekking in Nepal.
    </p>
    <p>
      Through HoneyGuide you can:
      <ol>
        <li>
          Give Accurate, Comprehensive and No-Strings-Attached Information to your friends.
          We strongly believe that trekkers should not be made to buy stuff through
          disinformation and fear.
        </li>
        <li>
          Refer Flights, Lodges, Treks, and Guides offered in HoneyGuide to your friends.
          Make sure they get Discounts through Promo Codes, and you get your Service Fee.
        </li>
        <li>Showcase HoneyGuide’s non-intrusive Merchandise in your property.</li>
      </ol>
    </p>
    <p>
      Some of the key features of working with HoneyGuide are:
      <ol>
        <li>Unmatched Transparency in everything we do from Content to Payments.</li>
        <li>Connect with Local Service Providers Directly.</li>
        <li>
          Sell your own Experiences. See an{' '}
          <a href="https://honeyguideapps.com/treks/trail-hike-nagarkot-to-dhulikhel.e53839115696.kathmandu-region">
            Experience sold by SherpaShah
          </a>{' '}
          BnB.
        </li>
      </ol>
    </p>
    <p>
      Just like Airbnb, we believe it is about time to democratize the adventure travel
      sector to unlock massive opportunities:
    </p>
    <p>
      If you have any questions, please contact: <br />
      Ashish Shrestha <br />
      +977-9841370673 <br />
      <a href="mailto:honeyhunter@honeyguideapps.com">honeyhunter@honeyguideapps.com</a>
    </p>
    <iframe
      src="https://docs.google.com/forms/d/e/1FAIpQLSel7eXA4f4sKRbZF5_L53_z4eftrvlMrAM67MPz7RAJOjAIig/viewform?embedded=true"
      width="100%"
      height="1078"
      frameBorder="0"
      marginHeight="0"
      marginWidth="0"
      title="Bed and Breakfast"
    >
      Loading...
    </iframe>

    <p>
      <strong>About HoneyGuide</strong> <br />
      HoneyGuide is a technology company that helps men and mountains meet more often. While
      we go about it, we are constantly guided by our belief that:
      <ol>
        <li>
          Providing Trekkers with No-strings attached and Accurate Information will make our
          mountains safer and help more people enjoy the thrills of a rarefied atmosphere.
        </li>
        <li>A Trekker should have the power to run a trek the way she sees fit easily.</li>
        <li>
          Connecting Local Service Providers with Trekkers will lead to a more equitable
          distribution of tourism dividends and increase service levels faster.
        </li>
      </ol>
    </p>
  </Page>
);

export default Bnb;



// WEBPACK FOOTER //
// ./src/screens/Partners/Bnb.jsx